import * as yup from 'yup';
import { i18n as I18n } from '../utils/i18n';
import { validateXSS, xssErrorMessage } from '../validators';

// A function rather than a constant: the labels interpolated into these
// validation messages are translations, and building the schema at module scope
// resolves them before i18next is initialised, so the errors would read as raw
// keys. (`xssErrorMessage` is itself a message function, so it stays lazy.)
export const getYupServiceSchema = () =>
  yup.object().shape({
    title: yup.string(),
    serviceType: yup.string().required(
      I18n.t('validations.required', {
        name: I18n.t('registration.service_details.fields.service_type.label'),
      })
    ),
    service: yup
      .string()
      .nullable()
      .required(
        I18n.t('validations.required', {
          name: I18n.t('registration.service_details.fields.service.label'),
        })
      ),
    serviceIdentifier: yup
      .string()
      .test('no-xss', xssErrorMessage, value => validateXSS(value as string)),
    isCommissionedService: yup.string(),
    serviceCommissioningBody: yup.string().when('isCommissionedService', {
      is: 'Yes',
      then: schema =>
        schema.required(
          I18n.t('validations.required', {
            name: I18n.t(
              'registration.service_details.fields.service_commissioning_body.label'
            ),
          })
        ),
    }),
    isLicensedForService: yup.string(),
    serviceLicensingBody: yup.string().when('serviceType', {
      is: 'Clinical',
      then: schema =>
        schema
          .trim()
          .test('no-xss', xssErrorMessage, value =>
            validateXSS(value as string)
          )
          .required(
            I18n.t('validations.required', {
              name: I18n.t(
                'registration.service_details.fields.service_governing_body.label'
              ),
            })
          ),
    }),
    serviceRegistrationNo: yup.string().when('serviceType', {
      is: 'Clinical',
      then: schema =>
        schema
          .trim()
          .test('no-xss', xssErrorMessage, value =>
            validateXSS(value as string)
          )
          .required(
            I18n.t('validations.required', {
              name: I18n.t(
                'registration.service_details.fields.service_registration_no.label'
              ),
            })
          ),
    }),
  });
